import { render, staticRenderFns } from "./hotel_popup.vue?vue&type=template&id=7bff0c98&scoped=true&"
import script from "./hotel_popup.vue?vue&type=script&lang=js&"
export * from "./hotel_popup.vue?vue&type=script&lang=js&"
import style0 from "./hotel_popup.vue?vue&type=style&index=0&id=7bff0c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bff0c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bff0c98')) {
      api.createRecord('7bff0c98', component.options)
    } else {
      api.reload('7bff0c98', component.options)
    }
    module.hot.accept("./hotel_popup.vue?vue&type=template&id=7bff0c98&scoped=true&", function () {
      api.rerender('7bff0c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/banner/hotel_popup.vue"
export default component.exports